<template>
  <div id="CarmellaApp">
    <v-header/>
    <Cart></Cart>
    <transition name="fade"></transition>

    <router-view ref="mainVue" keep-alive></router-view>

		<modal name="office-core-coordinates-failed" height="auto">
			<OfficeCoreCoordinatesFailedPopup />
		</modal>
		<modal name="office-core-slots-failed" height="auto">
			<OfficeCoreSlotsFailedPopup />
		</modal>

		<modal
			name="prod-modal"
			height="auto"
			:scrollable="true"
			:reset="true"
			@before-close="closeProductPop"
			@before-open="beforeProductPop"
		>
      <product-popup v-bind:product="this.$store.state.ProductPop"></product-popup>
    </modal>
    <modal
        name="login-modal"
        height="auto"
        :scrollable="true"
        :clickToClose="clickToClose"
        @before-open="beforeOpen"
        :delay="100"
    >
      <login-popup :state="loginState"/>
    </modal>
    <modal
        name="product-note"
        height="auto"
        :scrollable="true"
        @before-open="beforeNotePop"
        @closed="NotePopClosed"
        :delay="100"
    >
      <product-note :product="productNotePop"/>
    </modal>
    <modal name="password-modal" heigth="auto" :scrollable="true">
      <password-pop/>
    </modal>
    <modal name="not-exist" height="auto">
      <not-exist/>
    </modal>
    <modal name="delivery" height="auto">
      <delivery/>
    </modal>
    <!-- <modal name="cvform">
      <cvform/>
    </modal>-->
    <modal name="sales-pop" @before-open="getSalesProducts" height="auto" @closed="salesClosed">
      <sales-pop :products="saleProducts" :title="saleProductsTitle"/>
    </modal>
    <modal name="exitsales-pop" @before-open="getSalesProducts" height="auto" @closed="salesClosed">
      <exit-sales-pop :products="saleProducts" :title="saleProductsTitle"/>
    </modal>
    <modal name="conditions" height="auto">
      <conditions/>
    </modal>
    <modal name="coupon" height="auto">
      <coupon/>
    </modal>
    <modal name="order-update" height="auto">
      <order-update/>
    </modal>
    <modal name="often" height="auto" @before-open="loadOften">
      <often :product="loadedOftenProduct "/>
    </modal>
    <modal name="GrindingLevels" height="auto" @before-open="loadOften">
      <GrindingLevels :product="loadedOftenProduct "/>
    </modal>
    <modal name="timeup" height="auto">
      <time-up/>
    </modal>
    <modal name="load-cart-preset" height="auto">
      <LoadCartPreset/>
    </modal>
    <modal name="minimum-order" height="auto">
      <MinimumOrder/>
    </modal>
    <modal name="weight-and-quantity" height="auto">
      <WeightAndQuantity/>
    </modal>
    <BottomBar v-if="this.$mq == 'mobile' && !['checkout','giftCardPurchase','giftCardSend', 'giftCardPay'].includes(this.$route.name)"/>
    <v-footer :pages="pages"/>
  </div>
</template>
<script>
import LoadCartPreset from "./components/Popups/LoadCartPreset.vue";
import Often from "./components/Popups/OftenPopup";
import GrindingLevels from "./components/Popups/GrindingLevels.vue";
import OrderUpdate from "./components/Popups/OrderUpdatePop";
import Coupon from "./components/Popups/CouponPop";
import Conditions from "./components/Popups/ConditionsPop";
import Cart from "./components/Cart/Cart";
import LoginPopup from "./components/Popups/LoginPopup";
import NotExist from "./components/Popups/NotExistPopup";
import Delivery from "./components/Popups/DeliveryPopup";
import ProductPopup from "./components/Popups/ProductPopup";
import VHeader from "./components/Header/Header";
import VFooter from "./components/Footer/Footer";
import ProductNote from "./components/Popups/ProductNote";
import OfficeCoreCoordinatesFailedPopup from "./components/Popups/OfficeCore/CoordinatesFailed.vue";
import OfficeCoreSlotsFailedPopup from "./components/Popups/OfficeCore/SlotsFailed.vue";
import PasswordPop from "./components/Popups/ForgotPassword";
import Cvform from "./components/Popups/CvForm";
import SalesPop from "./components/Popups/SalesPopup";
import TimeUp from "./components/Popups/TimeupPop";
import ExitSalesPop from "./components/Popups/ExitSalePop";
import BottomBar from "./components/Mobile/BottomBar";
import MinimumOrder from "./components/Popups/MinimumOrder";
import WeightAndQuantity from "./components/Popups/WeightAndQuantity.vue";

export default {
  data() {
    return {
      loginState: "",
      pages: [],
      historyPath: '',
      productPop: "",
      productNotePop: '',
      clickToClose: true,
      saleProducts: "",
      saleProductsTitle: "",
      loadedOftenProduct: "",
      loaderGif: wpData.assets_url + "/layout/loader.gif"
    };
  },
  created() {
    this.$store.commit("setCities", wpData.cities);
  },
  methods: {
    salesClosed(event) {
      this.saleProducts = "";
      this.saleProductsTitle = "";
      let $cart = document.getElementById('appCart');
      if ($cart.style.display == 'block') {
        document.body.classList.add('noscroll');
      }
    },
    getSalesProducts(event) {
      this.saleProducts = event.params.products;
      if (typeof event.params.title != 'undefined' && event.params.title) {
        this.saleProductsTitle = event.params.title;
      }
    },
    show() {
      this.$modal.show("prod-modal");
    },
    hide() {
      this.$modal.hide("prod-modal");
    },
    beforeOpen(event) {
      this.loginState = event.params.state;
    },
    beforeProductPop(event) {
      console.log(event);
      //this.productPop = event.params.product;
    },
    loadOften(event) {
      this.loadedOftenProduct = event.params.product;
    },
    closeProductPop(e) {
      if (this.historyPath && this.historyPath.name == 'product') {
        this.$router.push({name: "category_sales"});
        return;
      }
      if (typeof this.$route.query.s != 'undefined' && this.$route.query.s) {
        return;
      }
      this.$router.push(this.historyPath);
    },
    beforeNotePop(e) {
      this.productNotePop = e.params.product;
    },
    NotePopClosed(e) {
      let $cart = document.getElementById('appCart');
      if ($cart.style.display == 'block') {
        document.body.classList.add('noscroll');
      }
    },
    sendImmpressions(e) {
      var list = [];

      //console.log(this.$refs.mainVue);
      //console.log(this.$refs.mainVue.$refs);
      if (
          typeof this.$refs.mainVue != "undefined" &&
          typeof this.$refs.mainVue.$refs.productComponent != "undefined"
      ) {

        var category = '';
        var list_name = this.$route.name.capitalize();
        if (this.$route.name == 'subcategory') {
          category = this.$route.params.subcat;
          list_name = this.$route.name.capitalize();
        }
        if (this.$route.name == 'category') {
          category = this.$route.params.cat;
          list_name = this.$route.name.capitalize();

        }
        var categories = this.$store.state.categories;
        this.$refs.mainVue.$refs.productComponent.map(function (value, key) {
          let productObj = {};
          let position = key + 1;
          let product_category = categories.find(cat => cat.id == value.product.categories[0]);
          productObj.id = value.product.id;
          productObj.name = value.product.name;
          productObj.price = value.product.price;
          productObj.category = product_category.name;
          productObj.list = list_name;
          productObj.position = position;
          list.push(productObj);
        });
      }
      var maxProducts = 5;
      while (list.length) {
        var p1 = list.splice(0, maxProducts);
        if (typeof dataLayer !== "undefined") {
          dataLayer.push({
            'event': 'impression',
            'ecommerce': {
              'currencyCode': 'ILS',
              'impressions': p1
            }
          });
        }
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.sendImmpressions();
      var disableSubmit = false;
      jQuery('input.wpcf7-submit[type="submit"]').click(function () {
        if (disableSubmit == true) {
          return false;
        }
        disableSubmit = true;
        return true;
      });
      var wpcf7Elm = document.querySelector('.wpcf7');
      if (wpcf7Elm) {
        wpcf7Elm.addEventListener('wpcf7_before_send_mail', function (event) {
          disableSubmit = false;
        }, false);
        wpcf7Elm.addEventListener('wpcf7invalid', function (event) {
          disableSubmit = false;
        }, false);
      }
    });
    this.$root.$on('scroll', () => {
      this.sendImmpressions();
    });

    // close product overlay on mobile on click
    if (this.$mq === 'mobile') {
      $(document).on('click', function (e) {
        if ($('.mobile-add-to-cart.show').length && !$(e.target).closest('.product_wrap').length) {
          $('.mobile-add-to-cart').removeClass('show');
          $('.product_friend_show').removeClass('product_friend_show');
        }
      });
    }
  },
  watch: {
    $route(to, from) {
      this.$nextTick(() => {
        this.sendImmpressions();
      })
    }
  },
  updated() {
    this.sendImmpressions();
    var disableSubmit = false;
    jQuery('input.wpcf7-submit[type="submit"]').click(function () {
      if (disableSubmit == true) {
        return false;
      }
      disableSubmit = true;
      return true;
    })

    var wpcf7Elm = document.querySelector('.wpcf7');
    if (wpcf7Elm) {
      wpcf7Elm.addEventListener('wpcf7_before_send_mail', function (event) {
        disableSubmit = false;
      }, false);

      wpcf7Elm.addEventListener('wpcf7invalid', function (event) {
        disableSubmit = false;
      }, false);
    }
  },
  computed: {
    categories() {
      return this.$store.state.categories.filter(cat => cat.parent === 0);
    },
  },
  components: {
    WeightAndQuantity,
    MinimumOrder,
    Cart,
    ProductPopup,
    VHeader,
    LoginPopup,
    VFooter,
    ProductNote,
    NotExist,
    Delivery,
    PasswordPop,
    Cvform,
    SalesPop,
    Conditions,
    Coupon,
    OrderUpdate,
    Often,
    GrindingLevels,
    TimeUp,
    ExitSalesPop,
    LoadCartPreset,
    BottomBar,
    OfficeCoreCoordinatesFailedPopup,
    OfficeCoreSlotsFailedPopup
  }
};
</script>